import React, { Fragment } from "react";
import { Footerdark, PageLayout } from "../../../Constant";
import AccountAddContainer from "./AccountAddContainer";

const AccountAdd = () => {
    return (
        <Fragment>
            <AccountAddContainer mainTitle={Footerdark} title={Footerdark} parent={PageLayout} />         
        </Fragment>
    )
}
export default AccountAdd;